import { MenuItem, useDisclosure } from '@chakra-ui/react';
import { IconChart2 } from 'central-icons/IconChart2';
import { IconWindowCursor } from 'central-icons/IconWindowCursor';
import { useState } from 'react';

import { FeatureFlag } from '@revelio/core';

import { useUnleashFlag } from '../../../../shared/unleash-flags/use-unleash-flag';
import { isScreenerV2Page } from '../../utils/routing-helpers';
import { usePageExport } from '../Chart/chart-menu/PageExportProvider';
import { getFileName } from '../Chart/utils/getFileName';
import { PptPreviewModal } from '../Modal/PptPreviewModal';
import {
  usePageConfig,
  useTabContentConfig,
} from '../PageConfigProvider/PageConfigProvider';
import { RevelioPageId } from '../PageConfigProvider/types';

export const PptExportMenuItem = () => {
  const { exportAllCharts, previewAllCharts } = usePageExport();
  const { config: pageConfig } = usePageConfig();
  const { config: tabContent } = useTabContentConfig();
  const isPPTPreviewEnabled = useUnleashFlag(FeatureFlag.PPTPreview);

  const defaultFileName = getFileName({
    primaryFilterId: tabContent.primaryFilter?.id,
    pageName: pageConfig.name,
  });

  const handleExportAllCharts = async () => {
    try {
      await exportAllCharts();
    } catch (error) {
      console.error('Error exporting all charts:', error);
    }
  };

  const [previewUrl, setPreviewUrl] = useState<string | undefined>(undefined);
  const [downloadUrl, setDownloadUrl] = useState<string | undefined>(undefined);
  const [editUrl, setEditUrl] = useState<string | undefined>(undefined);
  const {
    isOpen: isPreviewOpen,
    onOpen: openPreview,
    onClose: closePreview,
  } = useDisclosure();

  const handleEditAllCharts = async () => {
    try {
      const url = await previewAllCharts();
      if (url) {
        setPreviewUrl(url.previewUrl);
        setDownloadUrl(url.downloadUrl);
        setEditUrl(url.editUrl);
        openPreview();
      }
    } catch (e) {
      console.error('Error previewing/editing dashboard PPT:', e);
    }
  };

  const isMenuItemVisible =
    pageConfig.revelioPageId !== RevelioPageId.TALENT_DISCOVERY &&
    !isScreenerV2Page(pageConfig.revelioPageId);

  if (!isMenuItemVisible) {
    return null;
  }

  return (
    <>
      <MenuItem onClick={handleExportAllCharts} icon={<IconChart2 size={16} />}>
        Download PPT
      </MenuItem>
      {isPPTPreviewEnabled && (
        <MenuItem
          onClick={handleEditAllCharts}
          icon={<IconWindowCursor size={16} />}
        >
          Preview PPT
        </MenuItem>
      )}
      <PptPreviewModal
        isOpen={isPreviewOpen}
        onClose={closePreview}
        title={defaultFileName || 'PowerPoint file editor'}
        previewUrl={previewUrl}
        downloadUrl={downloadUrl}
        editUrl={editUrl}
      />
    </>
  );
};
